import DeleteModalSecondary from '@/components/Modals/DeleteModalSecondary';
import { useDeleteAgentFromLibrary } from '@/pages/agents/api';
import { useAnalytics } from '@/services/analytics';
import { IAgent } from '@d-id/types';

interface Props {
    itemToDelete: IAgent | null;
    onClose: () => void;
}

export const DeleteAgentModal = ({ itemToDelete, onClose }: Props) => {
    const mixpanel = useAnalytics();
    const { mutateAsync: deleteItem, isLoading: isDeleting } = useDeleteAgentFromLibrary();

    const onItemDelete = async () => {
        if (itemToDelete) {
            mixpanel?.track('agent-delete', {
                event: 'click',
                from: 'library',
                agentId: itemToDelete.id,
            });
            await deleteItem(itemToDelete.id || '');
            onClose();
        }
    };

    return (
        <DeleteModalSecondary
            itemType="agent"
            mode="square"
            open={!!itemToDelete}
            isLoading={isDeleting}
            onDelete={onItemDelete}
            onClose={onClose}
            poster={itemToDelete?.preview_thumbnail ?? itemToDelete?.presenter?.thumbnail ?? ''}
            text={{
                title: 'Delete this agent?',
                content: 'This agent will be permanently deleted from your Agent Library',
                cta: 'Delete agent',
            }}
        />
    );
};
